<template>
  <div class="item-container">
    <div
      class="item-main"
      :class="{ 'item-active': dropdown }"
      @click="toggleExpand"
    >
      <div class="item-title">
        <i class="icon-vouchers_and_documents glyph-lg pr-3"/>
        <span>NOTES</span>
      </div>
      <!-- For positioning purposes only -->
      <div></div>
      <div></div>
      <!-- End of positional elements -->
      <div class="toggle">
        <span v-if="!dropdown">+</span>
        <span v-else>-</span>
      </div>
    </div>
    <div v-if="dropdown" class="item-dropdown">
      <div class="notes-heading">
      </div>
      <div v-if="notesData" class="item-dropdown-main notes-item-dropdown">
        <ul>
          <li
            v-for="(note, index) in notesData"
            :key="index"
            v-html="note"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notes: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      dropdown: true,
      notesData: [],
    };
  },
  methods: {
    notesList() {
      if (!this.notes) return null;
      this.notesData = this.notes.map(function (element) {
        let output = "";
        element.fnotes.forEach(function (fnote) {
          if (fnote !== "") {
            output += fnote + "<br/>";
          }
        });
        if (element.description) {
          output += element.description;
        }
        return output;
      });
    },
    toggleExpand() {
      this.dropdown = !this.dropdown;
    },
    expandAll() {
      this.dropdown = true;
    },
    collapseAll() {
      this.dropdown = false;
    },
  },
  mounted() {
    // this.toggleExpand();
    this.notesList();
    
    this.$root.$on("collapseall", () => {
      this.collapseAll();
    });
    this.$root.$on("expandall", () => {
      this.expandAll();
    });
  },
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
